import { ZodError } from "zod";
import { CartImplementationError } from "../errors/cart-implementation-error.js";

export const makeMapParseErrorToCartError =
    (userErrorMessage: string) =>
    (err: unknown): Promise<never> => {
        if (err instanceof ZodError) {
            const firstIssue = err.issues[0];

            throw new CartImplementationError(userErrorMessage, {
                issues: err.issues,
                description: firstIssue?.message ?? "Unknown validation error",
            });
        }

        throw new CartImplementationError(userErrorMessage, {
            description:
                err instanceof Error ? err.message : "Unknown validation error",
        });
    };
